// Billet « prochain spectacle » collant en bas de page (templates/components/billet.twig) : il apparaît après 300 px de
// défilement (maquette) ou, sans défiler, 3,5 s après le chargement — sauf sur la page d'accueil, dont le hero porte déjà
// la carte « Prochaine représentation » en bas de l'écran (.hero-prochaine) ; il se ferme pour la session (sessionStorage)
// et un onglet « Billetterie » le rouvre
const BILLET_SCROLL_FROM = 300
const BILLET_AUTO_DELAY = 3500
const BILLET_STORAGE_KEY = 'alphabet-billet-ferme'

const billet = document.querySelector('.billet')
const onglet = document.querySelector('.billet-onglet')

if (billet && onglet) {
  let scrolled = false
  let ferme = false
  try {
    ferme = window.sessionStorage.getItem(BILLET_STORAGE_KEY) === '1'
  } catch (error) {
    ferme = false // stockage de session indisponible (navigation privée) : le billet se ferme pour la page seulement
  }

  const update = () => {
    const visible = scrolled && !ferme
    billet.classList.toggle('is-visible', visible)
    billet.setAttribute('aria-hidden', String(!visible))
    onglet.classList.toggle('is-visible', scrolled && ferme)
    // le bouton « retour en haut » d'Alpha se place au-dessus du billet ou de l'onglet (components/_billet.scss)
    document.body.classList.toggle('has-billet-visible', visible)
    document.body.classList.toggle('has-billet-onglet', scrolled && ferme)
    document.documentElement.style.setProperty('--billet-hauteur', `${billet.offsetHeight}px`)
  }
  const onScroll = () => {
    const isScrolled = window.scrollY > BILLET_SCROLL_FROM
    if (isScrolled !== scrolled) {
      scrolled = isScrolled
      update()
    }
  }

  billet.hidden = false
  onglet.hidden = false
  update()
  window.addEventListener('scroll', onScroll, {
    passive: true
  })
  onScroll()
  if (!document.querySelector('.hero-prochaine')) {
    window.setTimeout(() => {
      if (!scrolled) {
        scrolled = true
        update()
      }
    }, BILLET_AUTO_DELAY)
  }
  window.addEventListener('resize', update, {
    passive: true
  })

  billet.querySelector('.billet-fermer').addEventListener('click', () => {
    ferme = true
    try {
      window.sessionStorage.setItem(BILLET_STORAGE_KEY, '1')
    } catch (error) {
      // stockage de session indisponible : rien à retenir
    }
    update()
  })
  // note Google : la fenêtre d'avis du plugin Business Reviews Bundle (badge masqué sous le billet) plutôt que la fiche Google
  // (le script du plugin déplace son badge en fin de body : on le cherche au clic, par la classe que Child.php lui ajoute)
  const talon = billet.querySelector('a.billet-talon')
  if (talon) {
    talon.addEventListener('click', (event) => {
      const badge = document.querySelector('.billet-avis-badge .rplg-badge2-btn')
      if (badge) {
        event.preventDefault()
        badge.click()
      }
    })
  }

  onglet.addEventListener('click', () => {
    ferme = false
    try {
      window.sessionStorage.removeItem(BILLET_STORAGE_KEY)
    } catch (error) {
      // stockage de session indisponible : rien à oublier
    }
    update()
  })
}
